import { useSearchParams } from 'react-router-dom';
import { useCallback, useMemo } from 'react';

/**
 * Sync react-tabs selectedIndex with ?tab= URL query parameter.
 * @param {string[]} tabKeys - e.g. ['overview','players','matches','events','shots','crosses']
 * @returns {{ selectedIndex: number, onSelect: (index: number) => void }}
 */
export function useTabFromUrl(tabKeys) {
  const [searchParams, setSearchParams] = useSearchParams();
  const tabParam = searchParams.get('tab');

  const selectedIndex = useMemo(() => {
    const idx = tabKeys.indexOf(tabParam);
    return idx >= 0 ? idx : 0;
  }, [tabParam, tabKeys]);

  const onSelect = useCallback((index) => {
    setSearchParams((prev) => {
      const next = new URLSearchParams(prev);
      next.set('tab', tabKeys[index]);
      return next;
    }, { replace: true });
  }, [setSearchParams, tabKeys]);

  return { selectedIndex, onSelect };
}
